module.exports = __webpack_public_path__ + "static/media/zelda-owl.e52f441d.png";